import { connect } from 'react-redux';
import { CreateButton } from '../components/index';

import { openGroupEditor } from '../actions';

const mapDispatchToProps = dispatch => (
  {
    createAction: () => {
      dispatch(openGroupEditor({ group: { name: '' }, isNew: true }));
    },
  }
);

const CreateTagGroup = connect(
  undefined,
  mapDispatchToProps,
)(CreateButton);

export default CreateTagGroup;



// WEBPACK FOOTER //
// ./src/containers/CreateTagGroup.js